module.exports = {
      id: "sports-usage",
      viewBox: "0 0 26.459 26.453",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#sports",
      toString: function () {
        return this.url;
      }
    }